export default __webpack_public_path__ + "static/media/add-contact.ae150140.svg";